<template>
  <ul class="sa-rating">
    <li v-for="(item, i) in data" :key="i">
      <div class="sa-coment-pro-date">
        <div class="sa-coment-pro-rating">
          <figure v-if="item.img" class="sa-avtar sa-avtar-sm">
            <img :src="item.img" alt="Doctor" class="sa-img-cover" />
          </figure>
          <figure v-else class="sa-avtar sa-avtar-sm">
            <img
              src="https://img.litedev.com/images/unknown-avtar.png"
              alt="Doctor"
              class="sa-img-cover"
            />
          </figure>
          <div class="sa-coment-pro-name">
            {{ item.sanar_uname }}
            <div class="sa-coment-star">
              <i
                v-for="rate in 5"
                :key="rate"
                :class="rate <= item.rtg ? 'icon-star' : 'icon-star-line'"
              ></i>
            </div>
          </div>
        </div>
        <div class="sa-coment-date">
          <i>Post date & time </i>
          <span>{{ item.created_on }}</span>
        </div>
      </div>
      <Review :review="item.review || ''"> </Review>
      <div class="sa-coment-apnt" v-if="item && item.sanar_uname != 'Unknown'">
        <div class="sa-coment-apt-det">
          <i>Appointment ID </i>: {{ item.apnt_id }},<i>
            Appointment Date & time :</i
          >
          {{ item.apnt_date }}
        </div>
      </div>
    </li>
    <li v-if="!data" class="sa-text-center">No reviews</li>
  </ul>
</template>
<script>
import Review from "./Review.vue";
export default {
  props: ["data"],
  components: {
    Review,
  },
};
</script>